// extracted by mini-css-extract-plugin
module.exports = {"blurb":"tribute_blurb__xJFSN"};